import { useTranslation } from "react-i18next"
import { useEffect } from "react"
import { useDeletePlayerGroupMutation } from "@/hooks/api/useSettingQuery"

import BasicButton from "@/components/button/BasicButton"
import Dialog from "@/components/dialog/Dialog"
import { createGlobalStore } from "@/stores/global"

import "./PlayerGroupDeleteDialog.scss"

export default function PlayerGroupDeleteDialog({
  open,
  idfTeamPlayerGroup,
  playerCount,
  onClose,
  setTabIndex,
}: {
  open: boolean
  idfTeamPlayerGroup: number
  playerCount: number
  onClose: () => void
  setTabIndex: (index: number) => void
}) {
  const { t } = useTranslation("")
  const { mutate: deletePlayerGroup, isSuccess, isError } = useDeletePlayerGroupMutation()
  const { setSnackBar } = createGlobalStore((state) => ({ setSnackBar: state.setSnackBar }))

  useEffect(() => {
    if (isSuccess) {
      setSnackBar({ open: true, message: t("messages.successUpdate"), severity: "success" })
    } else if (isError) {
      setSnackBar({ open: true, message: t("messages.errorUpdate"), severity: "error" })
    }
  }, [isSuccess, isError])

  const onDelete = () => {
    deletePlayerGroup(idfTeamPlayerGroup)
    setTabIndex(0)
    onClose()
  }

  return (
    <Dialog
      className="PlayerGroupDeleteDialogCont"
      open={open}
      title={t("confirm")}
      maxWidth="400px"
      onClose={onClose}
      footer={
        <>
          <BasicButton type="default-outlined" size="md" onClick={onClose}>
            {t("button.cancel")}
          </BasicButton>
          <BasicButton type="danger-outlined" size="md" onClick={onDelete}>
            {t("button.delete")}
          </BasicButton>
        </>
      }>
      {playerCount ? (
        <>
          {t("playerGroupDeleteMessage", { playerCount })}
          <br />
        </>
      ) : null}
      {t("messages.confirmDelete")}
    </Dialog>
  )
}
